module.exports = __webpack_public_path__ + "img/BANDEAU_POINTAGES.ef6d0705.svg";